// extracted by mini-css-extract-plugin
export var container = "F2XKF";
export var detailsMessage = "aMihS";
export var mainMessage = "OeChX";